import { MessagesType } from '@telialt/common-cms/src/model';
import { SearchFilters } from '@telialt/core-search/src/model';

import { FACET_QUERY_KEY_MAP } from './constants';
import { ParamReadyFacetFilter } from './model';

const toWhole = (value: number | string) => Number(value)?.toFixed(0);
export const toWholeNumber = (value: number | string) => Number(toWhole(value));
export const splitByMainCommas = (value: string): string[] => value?.split(/,(?!\s|\d{2,})/).map((s) => s.trim());

export const toRangeParam = (min: number, max: number) => `${toWholeNumber(min)},${toWholeNumber(max)}`;
export const toRangeValue = (query: string) => {
    const split = query
        ?.split(',')
        .map(toWholeNumber)
        .filter((num) => !isNaN(num));

    return split && split.length === 2 && { gte: split[0], lte: split[1] };
};
export const toTermsParam = (titles: string[]) => titles?.join(',');
export const toTermsValue = splitByMainCommas;
export const toSearchFilters = (filters: ParamReadyFacetFilter[]) =>
    filters.reduce((acc, filter) => ({ ...acc, [filter.key]: filter.value }), {} as SearchFilters);

export const extractKnownFiltersFromQuery = (searchParams: { [key: string]: string | undefined }, t: MessagesType) =>
    Object.entries(FACET_QUERY_KEY_MAP).reduce((acc, [key, messageID]) => {
        const paramKey = t[messageID];
        const paramValue = searchParams?.[paramKey];
        if (!paramValue) {
            return acc;
        }
        switch (key as keyof typeof FACET_QUERY_KEY_MAP) {
            case 'connectionTechnology':
            case 'benefitNames':
                const termsValue = toTermsValue(paramValue);
                if (!termsValue?.length) {
                    return acc;
                }

                return { ...acc, [key]: termsValue };
            case 'dataSizeDomesticTotal':
            case 'dataSizeEuropeTotal':
            case 'price':
                const rangeValue = toRangeValue(paramValue);
                if (!rangeValue) {
                    return acc;
                }

                return { ...acc, [key]: rangeValue };
            default:
                return acc;
        }
    }, {});
